const BLACK = 'black';
const RED = 'red';
const FILLING = 'FILLING';
const ROTATION = 'ROTATION';
const COUNTER = 'counter';
const CLOCK = 'clock';

export { BLACK, RED, FILLING, ROTATION, COUNTER, CLOCK };
